import { call, takeEvery } from 'redux-saga/effects';
import { SettlementConstants } from 'constants/settlement';
import { request } from 'components/Fetch';

function* getSettlements(action) {
  yield call(request({
    type: SettlementConstants.GET_SETTLEMENTS,
    method: 'GET',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

function* confrimCDA(action) {
  yield call(request({
    type: SettlementConstants.CONFIRM_CDA,
    method: 'PUT',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

function* updateCounterOfferStatus(action) {
  yield call(request({
    type: SettlementConstants.UPDATE_COUNTER_OFFER_STATUS,
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

export default function* () {
  yield takeEvery(SettlementConstants.GET_SETTLEMENTS, getSettlements);
  yield takeEvery(SettlementConstants.UPDATE_COUNTER_OFFER_STATUS, updateCounterOfferStatus);
  yield takeEvery(SettlementConstants.CONFIRM_CDA, confrimCDA);
}



// WEBPACK FOOTER //
// ./src/sagas/settlementSaga.js